import {
  useEffect, useState
} from 'react';

import {
  QuestionWithOnboardingText
} from '../types';

export const useSetOnboardingTextList = (
  defaultQuestionsData?: QuestionWithOnboardingText[],
) => {
  const [questionsOnboardingText, setQuestionsOnboardingText] = useState<
  QuestionWithOnboardingText[]
  >([]);

  useEffect(
    () => {
      if (defaultQuestionsData?.length) {
        setQuestionsOnboardingText(defaultQuestionsData);
      }
    },
    [defaultQuestionsData]
  );

  const handleOnboardingTextChange = (id: string, value: string) => {
    setQuestionsOnboardingText((prev) => {
      return prev.map((item) => {
        if (item.id !== id) {
          return item;
        }

        return {
          ...item,
          onboardingText: value,
        };
      });
    });
  };

  return {
    questionsOnboardingText,
    onTextChange: handleOnboardingTextChange,
  };
};
